<template>
  <div class="tenancy-settings">
    <h2 class="mb-5">{{ defaultHeader }}</h2>

    <div class="tenancy-settings__wrapper">
      <TenancyTerminate :landlord-id="landlordId" :tenancy-id="tenancyId" />

      <div class="col d-flex">
        <UpdateSubscription v-if="!isFree" :compact-layout="false" :landlordId="landlordId" :tenancyId="tenancyId" />
      </div>
    </div>

    <div class="tenancy-settings__wrapper mt-5">
      <TenancyBankInfo :landlordId="landlordId" :tenancyId="tenancyId" />

      <div ref="kpi" class="col d-flex">
        <TenancyCPIAdjustment class="flex-fill" :landlordId="landlordId" :tenancyId="tenancyId" />
      </div>
    </div>

    <div class="row mt-5">
      <div class="col">
        <CustomerInformation :landlord-id="landlordId" :tenancy-id="tenancyId" />
      </div>
    </div>
  </div>
</template>

<script>
import TenancyCPIAdjustment from '@/components/tenancy/settings/TenancyCPIAdjustment';
import subscription from '@/mixins/tenancy/subscription';
import CustomerInformation from '@/components/profile/CustomerInformation.vue';
import TenancyTerminate from '@/components/tenancy/tenancy/TenancyTerminate.vue';
import TenancyBankInfo from '@/components/tenancy/tenancy/TenancyBankInfo';
import UpdateSubscription from '@/components/upsale/UpdateSubscription';

export default {
  props: {
    tenancyId: [String, Number],
    landlordId: [String, Number],
    defaultHeader: String,
  },
  components: {
    CustomerInformation,
    TenancyCPIAdjustment,
    TenancyTerminate,
    TenancyBankInfo,
    UpdateSubscription,
  },

  mixins: [subscription],

  mounted() {
    if ('highlight' in this.$route.query) {
      const ref = this.$route.query.highlight;
      if (this.$refs[ref]) {
        this.$refs[ref].classList.add('ui-highlight');
        this.$refs[ref].scrollIntoView({ behavior: 'smooth' });

        window.setTimeout(() => {
          this.$refs[ref].classList.remove('ui-highlight');
        }, 3000);
      }
    }
  },
};
</script>

<style>
.tenancy-settings .ui-highlight {
  @apply z-[1091] !relative;
}

.tenancy-settings .ui-highlight .blockContainer {
  @apply animate-ping border-4 border-green border-solid;
}

.tenancy-settings__wrapper {
  @apply grid grid-cols-2 gap-3;
}

@keyframes ping {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}
</style>
